import { createContext } from 'react';

const BrowserContext = createContext({ lessThan: {}, greaterThan: {}, is: {} });

export default BrowserContext;
